module.exports = __webpack_public_path__ + "static/img/hangye_3@2x.2fc92016.png";